"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _once = _interopRequireDefault(require("transmute/once"));

var LocalSettings = _interopRequireWildcard(require("crm_data/settings/LocalSettings"));

function logProfileMountTiming() {
  if (LocalSettings.getFrom(localStorage, 'RECORD_TIMINGS')) {
    // eslint-disable-next-line no-console
    console.log('Profile mounted at: ', performance.now());
  }

  if (window.newrelic) {
    window.newrelic.setCustomAttribute('profile-load-time', performance.now());
  }
}

var _default = (0, _once.default)(logProfileMountTiming);

exports.default = _default;
module.exports = exports.default;